<template>
    <div class="lc_chat">

        <!-- 1) chat body -->
        <div class="lc_messageWrapper " v-for="(message_c, index_n) in co_messagesByTime_ac" :key="index_n"
             :class="{'lc_firstMsg' : index_n>0 && m_notEqualToLastMsg(message_c.ms_sendTime_n)}">

            <!-- 1) current user msg -->
            <div v-if="p_currentUser_c && message_c.ms_senderId_uid === p_currentUser_c.ud_userId_uid"
                 class="lc_message TQ_selectable TQ_textAlign_end">

                <div class="lc_messageBody lc_myMessage TQ_inline TQ_textAlign_initial"
                     :style="{'direction' : helper_getDirectionByLangCode_fe(p_systemLangCode_e)}"
                     :class="{
                        [helper_getDirectionByLangCode_fe(p_systemLangCode_e)] : true,
                        'lc_creatorMessage': message_c.ms_senderId_uid === p_creatorId_uid,
                        }">

                    <div :class="{'emoji' : m_dom_isEmoji_fb(message_c.ms_text_s)}" class="lc_text TQ_font_emoji">{{message_c.ms_text_s}}</div>

                    <div class="lc_date"
                         :class="{'alignRight': !co_dom_directionLtr_b, 'alignLeft': co_dom_directionLtr_b}">
                         <tq-loader-container :p_showLoader_b="!message_c.wsr_serverReceivedData_b" p_ballSize_s="6px">
                            {{formatDate(message_c.ms_sendTime_n)}}
                            <div class="TQ_inline TQ_verticalAlignMiddle">
                                <img v-if="m_dom_getMsgStatus_fe(message_c) === enum_chatMsgStatus.readByAll"
                                    class="TQ_width_16px" :src="ass_img_check_simple_two_purple"/>
                                <img v-else-if="m_dom_getMsgStatus_fe(message_c) === enum_chatMsgStatus.receiveByAll"
                                    class="TQ_width_16px" :src="ass_img_check_simple_two"/>
                                <img v-else-if="m_dom_getMsgStatus_fe(message_c) === enum_chatMsgStatus.send"
                                    class="TQ_width_16px" :src="ass_img_check_simple"/>

                            </div>
                        </tq-loader-container>

                    </div>
                </div>
            </div>

            <!-- 2) other user msg -->
            <div v-else class="lc_message TQ_selectable TQ_textAlign_initial">

                <div class="lc_userImage TQ_inline" v-if="m_notEqualToLastMsg(message_c.ms_sendTime_n) && m_getUserData_fc(message_c.ms_senderId_uid)">

                    <tq-avatar :p_ud_avatar_c="m_getUserData_fc(message_c.ms_senderId_uid).data.ud_avatar_c"
                               class="TQ_width_36px TQ_borderRadius"/>

                    <div class="TQ_padding_4px TQ_inline"></div>

                </div>

                <div class="lc_messageBody lc_otherMsg TQ_inline"
                     :style="{'direction' : helper_getDirectionByLangCode_fe(p_systemLangCode_e)}"
                     :class="{
                        [helper_getDirectionByLangCode_fe(p_systemLangCode_e)] : true,
                        'lc_creatorMessage': message_c.ms_senderId_uid === p_creatorId_uid,
                     }">

                    <div v-if="m_notEqualToLastMsg(message_c.ms_sendTime_n) && m_getUserData_fc(message_c.ms_senderId_uid)"
                         class="lc_sendBy" :style="{ color:  m_getUserData_fc(message_c.ms_senderId_uid).color}">
                        {{m_getUserData_fc(message_c.ms_senderId_uid).data.ud_name_s}}
                    </div>

                    <!-- text -->
                    <div :class="{'emoji' : m_dom_isEmoji_fb(message_c.ms_text_s)}" class="lc_text TQ_font_emoji">{{message_c.ms_text_s}}</div>

                    <!-- translate -->
                    <div class="TQ_padding_2px_0 TQ_clickable TQ_text_bold TQ_textColor_purple TQ_text_14px" v-if="p_showTranslation_b && p_systemLangCode_e !== message_c.ms_langCode_e">
                        <div v-if="!p_msgShowTranslate_byMsgTime_b[message_c.ms_sendTime_n]" class="TQ_clickable TQ_text_underline TQ_text_capitalize" @click="pe_translateMsg_f(message_c)" >
                            {{ass_strings.oneWord_translate[p_systemLangCode_e]}}
                        </div>
                        <tq-loader-container v-else :p_show-loader_b="message_c.ms_translate_blc_s[p_systemLangCode_e] === null"
                                             class="TQ_clickable TQ_text_bold TQ_textColor_purple TQ_text_14px"
                                             :class="{'emoji' : m_dom_isEmoji_fb(message_c.ms_text_s)}">
                            {{message_c.ms_translate_blc_s[p_systemLangCode_e]}}
                        </tq-loader-container>
                    </div>

                    <!-- date-->
                    <div class="lc_date"
                         :class="{'alignRight': !co_dom_directionLtr_b, 'alignLeft': co_dom_directionLtr_b}">
                        {{formatDate(message_c.ms_sendTime_n)}}
                    </div>
                </div>

            </div>

        </div>

    </div>
</template>

<script>

    import {format_date_hh_mm_fs} from "../../../functions/src/shareCode/Share_S_Format";
    import MyVideo from "../mediaComponenets/MyVideo";
    import {serverAuth_getOtherUserData_f} from "../../scripts/Server/S_ServerAuth";
    import TqTextareaAutosize from "../basic/TqTextareaAutosize";
    import TqDropdown from "../basic/TqDropdown";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {gv_emoji, gv_zIndex} from "../../scripts/S_GlobalVar";
    import {validator_objClass_fb, validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import {
        enum_langCodes
    } from "../../../functions/src/shareCode/Share_S_Enum";
    import {helper_getDirectionByLangCode_fe} from "../../scripts/S_Helper";
    import TqOnTopContainer from "../basic/TqOnTopContainer";
    import TqNotificationContainer from "../basic/TqNotificationContainer";
    import {
        ass_img_check_simple,
        ass_img_check_simple_two,
        ass_img_check_simple_two_purple, ass_img_user_b,
    } from "../../assets/scripts/Ass_Files";
    import {obj_size_fn} from "../../../functions/src/shareCode/Share_S_Obj";
    import {FB_Message, FB_UserData} from "../../../functions/src/shareCode/Share_S_Classes";
    import {enum_chatMsgStatus, enum_directions} from "../../../functions/src/shareCode/Share_S_Enum";
    import TqPopup from "../basic/TqPopup";
    import TqToggleDiv from "../basic/TqToggleDiv";
    import TqTable from "../basic2/TqTable";
    import TqBtnApprove from "../basic2/TqBtnApprove";
    import TqDisplayFile from "../mediaComponenets/TqDisplayFile";
    import TqImage from "../basic/TqImage";
    import TqAvatar from "@/components/complex/TqAvatar";
    import {gv_colorsDark} from "../../../functions/src/shareCode/Share_Ass_GlobalVariable";
    import TqLoaderContainer from "@/components/basic/TqLoaderContainer";

    export default {
        name: "TqChat_messages",
        components: {
            TqLoaderContainer,
            TqAvatar,
            TqImage,
            TqDisplayFile,
            TqBtnApprove,
            TqTable,
            TqToggleDiv,
            TqPopup,
            TqNotificationContainer,
            TqOnTopContainer,
            TqDropdown,
            TqTextareaAutosize,
            MyVideo
        },
        props: {

            p_systemLangCode_e:{
                type: String,
                require: true,
                validator(val){
                    return validator_enum_fb(enum_langCodes, val)
                }
            },
            p_currentUser_c:{
                type: FB_UserData,
                require:true
            },
            p_creatorId_uid:{
                type: String,
                require: true
            },
            p_messages_bySendTime_c: {
                type: Object,
                require:true,
                validator: (obj) => {
                    return validator_objClass_fb(obj, FB_Message)
                }
            },
            p_allPlayerJoinTime_byPlayerId_c:{
                type: Object,
                default : () => {
                    return {}
                }
            },
            p_msgShowTranslate_byMsgTime_b:{
                type: Object,
                default : () => {
                    return {}
                }
            },
            p_showTranslation_b:{
                type: Boolean,
                default: false,
            },


            pe_mounted_f:{
                type : Function
            },
            pe_translateMsg_f : {
                type : Function
            }
        },
        data(){
            return{
                usersById       : {},
                sendMsg_text_s  :  "",
                colorIndex      : 0,
                prevMsg_senderId_uid_c       : null,

                // imports
                ass_colors                      : gv_colorsDark,
                ass_img_check_simple_two_purple : ass_img_check_simple_two_purple,
                ass_img_check_simple_two        : ass_img_check_simple_two,
                ass_img_check_simple            : ass_img_check_simple,
                ass_img_user_b                  : ass_img_user_b,
                ass_emoji                       : gv_emoji,
                enum_chatMsgStatus              : enum_chatMsgStatus,
                enum_directions                 : enum_directions,
                ass_strings                     : ass_strings,
                gv_zIndex                       : gv_zIndex,
                helper_getDirectionByLangCode_fe: helper_getDirectionByLangCode_fe,
                formatDate                      : format_date_hh_mm_fs,
                obj_size_fn                     : obj_size_fn,

            }
        },
        computed:{
            co_dom_directionLtr_b(){
                return helper_getDirectionByLangCode_fe(this.p_systemLangCode_e) === enum_directions.rtl
            },
            co_getColor_s(){
                return this.ass_colors[this.colorIndex++]
            },
            co_messagesByTime_ac(){
                if(!this.p_messages_bySendTime_c){
                    return []
                }

                return Object.values(this.p_messages_bySendTime_c).sort((msg1_c, msg2_c) => msg1_c.ms_sendTime_n > msg2_c.ms_sendTime_n ? 1 : -1)
            }
        },
        methods:{

            m_notEqualToLastMsg(currentMsgTimestamp_t){

                let messagesTimestamp_at = Object.keys(this.p_messages_bySendTime_c)
                let msgTimestampIndex_n = messagesTimestamp_at.indexOf(currentMsgTimestamp_t)
                let prevMsgTimestamp_t = messagesTimestamp_at[msgTimestampIndex_n - 1]


                if(msgTimestampIndex_n <= 0 ){
                    return true
                }

                let currentMsg = this.p_messages_bySendTime_c[currentMsgTimestamp_t]
                let prevMSg = this.p_messages_bySendTime_c[prevMsgTimestamp_t]


                return currentMsg.ms_senderId_uid !== prevMSg.ms_senderId_uid
            },
            m_getUserData_fc(userId_uid){
                if(this.usersById[userId_uid]){
                    return this.usersById[userId_uid]
                }
                if(this.usersById[userId_uid] === undefined ){

                    this.$set(this.usersById, userId_uid, null)

                    serverAuth_getOtherUserData_f(userId_uid, userData_c =>{
                        this.$set(this.usersById, userId_uid,
                            {
                                data    : userData_c,
                                color   : this.co_getColor_s
                            })
                    })

                }
                return null
            },

            // dom
            m_dom_isEmoji_fb(str) {
                if(this.ass_emoji.includes(str)){
                    return true
                }
                return false;
            },
            m_dom_getMsgStatus_fe(msg_c){

                let allUsersReceived = true
                let allUsersRead = true

                for(let playerId_uid in this.p_allPlayerJoinTime_byPlayerId_c) {
                    if (!msg_c.ms_receiveMsg_byUserId_b[playerId_uid])
                        allUsersReceived = false
                    if (!msg_c.ms_readMsg_byUserId_b[playerId_uid])
                        allUsersRead = false
                }

                if(allUsersRead) {
                    return enum_chatMsgStatus.readByAll
                }else if(allUsersReceived){
                    return enum_chatMsgStatus.receiveByAll
                }
                return enum_chatMsgStatus.send
            },

        },

        // life circle
        mounted(){
            if(this.pe_mounted_f){this.pe_mounted_f()}
        },
    }

</script>

<style scoped lang="scss">


    .lc_chat {
        height: 100%;

        .lc_messageWrapper {

            &.lc_firstMsg{
                margin-top: 8px;
            }

            .lc_message {
                display: flow-root;

                .lc_userImage{
                    vertical-align: top;
                }

                .lc_messageBody{

                    background: var(--color-gray4);
                    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);

                    margin-bottom: 4px;
                    padding: 8px;


                    &.lc_otherMsg{
                        &.ltr {
                            border-radius: 0px 8px 8px 8px;
                        }
                        &.rtl{
                            border-radius: 8px 0px 8px 8px;

                        }
                    }
                    &.lc_myMessage {
                        background: var(--color-purple_lite3);
                        &.ltr {
                            border-radius: 8px 0px 8px 8px;
                        }
                        &.rtl{
                            border-radius: 0px 8px 8px 8px;
                        }
                    }
                    &.lc_creatorMessage {
                        background: var(--color-gold-light);
                    }

                    .lc_sendBy{
                        font-size: 14px;
                    }

                    .lc_date{
                        font-size: 12px;

                        &.alignLeft{
                            text-align: left;
                            margin-right: 42px;
                        }

                        &.alignRight{
                            text-align: right;
                            margin-left: 42px;
                        }

                    }
                }
            }
        }


    }


    .lc_text {
        white-space: pre-line;
        word-break: break-word;
        &.emoji{
            font-size: 32px;
        }
    }



</style>
